import React from 'react'
import { useLocation } from 'react-router-dom'
import { CHAT_ROUTE } from '../../utils/consts'
import CookiePopup from '../ui/CookiePopup/CookiePopup'
import Footer from '../ui/Footer/Footer'
import Navbar from '../ui/Navbar/Navbar'
import styles from './Layout.module.scss'

export default function LayoutClient({ children }) {
	const location = useLocation()
	const isChatPage = location.pathname.startsWith(CHAT_ROUTE)

	return (
		<main className={`${styles.layout}`}>
			<Navbar />
			<section className='flex-1 flex'>{children}</section>
			<CookiePopup />
			<Footer />
		</main>
	)
}
